import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Dropdown, Image, Media, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faAngleDoubleLeft } from '@fortawesome/free-solid-svg-icons';
import carLogo from '../../../assets/images/car_graphic_icon.png';
import PaymentCartLogo from '../../../assets/images/Icons/EmptyCartIcon.svg';
import LoanCartLogo from '../../../assets/images/Icons/Loan-cart-Icon.svg';
import PaymentCartActiveLogo from '../../../assets/images/shopping-cart-ative-icon.png';
import LoanCartActiveLogo from '../../../assets/images/header-cart-car-color-img.png';
import { AlertTriangle, Edit, Key, LogOut, Trash2 } from 'lucide-react'
import './Header.css';
import '../../Shared/css/common.css'
import { convertToBaseFormatDate, currencifyInDollars, getLoanTypes } from '../../../commonservices/CommonMethods';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import callAPI from '../../../commonservices/APIRequests';
import Toaster from '../../../components/Shared/Toaster/Toaster';
import { getDDRCart, readNotifications } from '../../../store/Actions/Actions';
import Loader from '../../Shared/Loader/Loader';
import NotesSquare from '../../../assets/images/Popup-Icons/PopupIcons_View_Dealer_Notes_Grey.svg';
import ViewNotes from "../NotesSharedModule/ViewNotes";
import deleteIcon from '../../../assets/images/Icons/deleteIcon.svg'
import { setCreateNotesData, setSharedNotes } from '../../../store/Reducers/Notes';
import SavestatusChecker from '../saveStatusChecker/saveStatusChecker';
import { lenderBanner } from '../../../store/Actions/Lender/CommonAction/CommonAction';
import TagsInfo from '../TagsInfo/TagsInfo';
import { changeAuctionTab, removeLenderSelectedDealerId, setLenderBanner } from '../../../store/Reducers/Shared';
import GlobalSearchField from '../GlobalSearchField/GlobalSearchField';
import Notifications from '../Notifications/Notifications';
const HeaderComponent = (props) => {
    const dispatch = useDispatch();
    let headerRef = useRef();
    const sharedReducerData = useSelector((store) => store.sharedReducer);
    const cartReducerData = useSelector((store) => store.cartReducer);
    const bankData = useSelector((store) => store.bankdetailsReducer);
    const userDetails = JSON.parse(localStorage.getItem('user'));
    const isLender = userDetails && userDetails.organization.toLowerCase() === 'lender'
    const isMultiDealerAdmin = localStorage.getItem('isMultiDealerAdmin');
    const multiDealerName = localStorage.getItem('multiDealerName') ? localStorage.getItem('multiDealerName') : '';
    const [showLoader, setShowLoader] = useState(false);
    const [profileRoute, setProfileRoute] = useState('');
    const location = useLocation();
    const lenderDealerPages = [
        '/admin/dealerdetails',
        '/admin/upcomingevents',
        '/admin/vehicledetails',
        '/admin/dealercheckout',
        '/admin/dealerloanrequest',
        '/admin/dealerprofile'
    ]
    const lenderSupplierPages = ['/admin/supplierdetails', '/admin/supplierprofile', '/admin/suppliercheckout'];
    const isLenderOrSupplier = (isLender || userDetails?.organization?.toLowerCase() === 'supplier')
    const [notesList, setNotesList] = useState([]);
    const [notesListModal, setNotesListModal] = useState(false);
    const isLoaded = useState(true);
    const navigate = useNavigate();

    const [notesListState, setNotesListState] = useState({
        dealerId: '',
        selectedDealer: {},
        showModal: false
    });
    const saveStatusChecker = useSelector((store) => store.saveStatusChecker?.saveStatusChecker);
    const [saveChanges, setSaveChanges] = useState(false)
    const [toaster, setToaster] = useState({
        header: '',
        class: '',
        content: '',
        showToaster: false
    })

    const toasterClose = () => {

        setToaster({
            header: '',
            class: '',
            content: '',
            showToaster: false
        })

    }
    // let breadCrumbLink = (userDetails && userDetails?.organization
    //     && userDetails?.organization?.toLowerCase() === "dealer" || userDetails?.organization?.toLowerCase() === "lender"
    //     ? 'AccountSettings' : 'AccountSettings')

    useEffect(() => {
        document.documentElement.style.setProperty('--header-height', `${headerRef?.current?.clientHeight}px`);
        if (sharedReducerData?.lenderSelectedDealerId && !isMultiDealerAdmin) {
            dispatch(lenderBanner(sharedReducerData?.lenderSelectedDealerDetails?._id, sharedReducerData?.lenderSelectedDealerDetails?.sopraDealerReference))
        } else if(sharedReducerData?.lenderSelectedSupplierId && !isMultiDealerAdmin){
            dispatch(lenderBanner(sharedReducerData?.lenderSelectedSupplierDetails?._id, sharedReducerData?.lenderSelectedSupplierDetails?.sopraSupplierReference, true))
        }

    }, []);

    const isLenderAccessedCustomerSupport = (sharedReducerData.lenderSelectedDealerId || sharedReducerData.lenderSelectedSupplierId) && location.pathname.toLowerCase() === '/admin/customersupport';

    useEffect(() => {

        if (!isLenderAccessedCustomerSupport) {

            if ((!sharedReducerData.lenderSelectedDealerId && lenderDealerPages.includes(location.pathname.toLowerCase())) || (!sharedReducerData.lenderSelectedSupplierId && lenderSupplierPages.includes(location.pathname.toLowerCase())))
                navigate('/Admin');

        }

        const fullUrl = window.location.href.toLowerCase();
        const originUrl = window.location.origin.toLowerCase();

        if (fullUrl.indexOf(originUrl + '/dealer') > -1)
            setProfileRoute('/Dealer/Profile');
        else if (fullUrl.indexOf(originUrl + '/admin') > -1) {
            if (lenderDealerPages.includes(location.pathname.toLowerCase()))
                setProfileRoute('/Admin/DealerProfile');
            else if (lenderSupplierPages.includes(location.pathname.toLowerCase()))
                setProfileRoute('/Admin/SupplierProfile');
            else
                setProfileRoute('/Admin/Profile');
        }
        else if (fullUrl.indexOf(originUrl + '/supplier') > -1)
            setProfileRoute('/Supplier/Profile');

    }, []);


    useEffect(() => {

        if ((userDetails && userDetails.organization.toLowerCase() === 'dealer') || (isLender && sharedReducerData.lenderSelectedDealerId))
            dispatch(getDDRCart(sharedReducerData.lenderSelectedDealerId));

    }, []);

    const logOut = () => {

        callAPI.post('/auth/api/v1/auth/logout', {})
            .then((response) => {

                if (response.status === 200) {

                    localStorage.clear();
                    navigate('/DealerLogin');
                    // props.setLogoutState();
                    dispatch({ type: 'USER_LOGGED_OUT' });

                }
                else {

                    localStorage.clear();
                    navigate('/DealerLogin');
                    // props.setLogoutState()
                    dispatch({ type: 'USER_LOGGED_OUT' });

                }

            })

    }

    const getNotes = () => {

        if (!sharedReducerData?.lenderSelectedSupplierDetails?._id) {

            const newObj = JSON.parse(JSON.stringify(sharedReducerData?.lenderSelectedDealerDetails))
            newObj['addedFrom'] = 'LENDER_DEALER_DASHBOARD';
            newObj['dealerId'] = sharedReducerData.lenderSelectedDealerDetails ? sharedReducerData.lenderSelectedDealerDetails._id : ''
            dispatch(setCreateNotesData({ notesData: newObj, noteType: 'Dealer Note', showAddNote: true }));

            setNotesListState({
                ...notesListState,
                dealerId: sharedReducerData.lenderSelectedDealerDetails ? sharedReducerData.lenderSelectedDealerDetails._id : '',
                selectedDealer: sharedReducerData.lenderSelectedDealerDetails ? sharedReducerData.lenderSelectedDealerDetails : '',
                showModal: true
            })
            dispatch(setSharedNotes());
            setShowLoader(true)
        }
        else {
            const newObj = JSON.parse(JSON.stringify(sharedReducerData?.lenderSelectedSupplierDetails))
            newObj['addedFrom'] = 'SUPPLIER_DETAILS';
            newObj['dealerId'] = sharedReducerData.lenderSelectedSupplierDetails ? sharedReducerData.lenderSelectedSupplierDetails._id : ''
            dispatch(setCreateNotesData({ notesData: newObj, noteType: 'Supplier Note', showAddNote: true }));

            setNotesListState({
                ...notesListState,
                dealerId: sharedReducerData.lenderSelectedSupplierDetails && sharedReducerData.lenderSelectedSupplierDetails._id ? sharedReducerData.lenderSelectedSupplierDetails._id : '',
                selectedDealer: sharedReducerData.lenderSelectedSupplierDetails ? sharedReducerData.lenderSelectedSupplierDetails : '',
                showModal: true
            })
            dispatch(setSharedNotes());
            setShowLoader(true)
        }
    }


    const removeVehicle = (vehicleId) => {

        setShowLoader(true);

        const req = {
            vehicleId: vehicleId,
        }

        if (sharedReducerData.lenderSelectedDealerId)
            req.dealer_id = sharedReducerData.lenderSelectedDealerId;

        return callAPI.del('/vehicle/api/v1/dealers/removeVehicle', req)
            .then((response) => {

                if (response.status === 200) {

                    dispatch(getDDRCart(sharedReducerData.lenderSelectedDealerId));


                    setShowLoader(false);
                    setToaster({
                        header: 'Success',
                        class: 'success-toaster',
                        content: 'Your Vehicle has been successfully removed to cart.',
                        showToaster: true
                    })



                }
                else {
                    setShowLoader(false);
                    setToaster({
                        header: 'Error',
                        class: 'error-toaster',
                        content: response.message,
                        showToaster: true
                    })

                }

            })

    }

// Function for handling keydown event
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent the default Enter key behavior
    }
  };

    const submitForFunding = () => {
        setShowLoader(true);

        const req = {
            vehicleIds: cartReducerData.drawdownrequestCart.map(item => item._id),
            dealer_id: sharedReducerData.lenderSelectedDealerId
        }

        const backupfoSuccess = [...cartReducerData.drawdownrequestCart];

        const toasterContent = cartReducerData.drawdownrequestCart.length + ' Vehicles have been submitted for funding.';



        return callAPI.post('/vehicle/api/v1/dealers/submittedForFunding', req)
            .then((response) => {

                if (response.status === 200) {
                    setShowLoader(false);
                    setToaster({
                        header: 'Success',
                        class: 'success-toaster',
                        content: toasterContent,
                        showToaster: true
                    })
                    dispatch(getDDRCart(sharedReducerData.lenderSelectedDealerId));
                    navigate(isLender ? '/Admin/DealerLoanRequest' : '/Dealer/LoanRequest', {
                        state: {
                            backupCartForSucessSection: backupfoSuccess,
                            backupTotalForSucessSection: cartReducerData.ddrTotalCost,
                        }
                    });

                }
                else {

                    setShowLoader(false);
                    setToaster({
                        header: 'Error',
                        class: 'error-toaster',
                        content: response.message,
                        showToaster: true
                    })


                }

            })

    }


    const ddrCart = cartReducerData.drawdownrequestCart && cartReducerData.drawdownrequestCart.length > 0 ?

        (<React.Fragment>

            {
                toaster.showToaster ?
                    <Toaster myClassName={toaster.class}
                        onClose={toasterClose} header={toaster.header}
                        content={toaster.content}></Toaster>
                    : null
            }
            <Dropdown alignRight={true} className="header-icons">

                <Dropdown.Toggle variant="success" id="dropdown-basic" className='complete-payment-btn'>
                    <OverlayTrigger onHide rootClose key="right" placement="bottom"
                        overlay={
                            <Tooltip id={`tooltip-brand`}>
                                Loan Request Cart
                            </Tooltip>
                        }>
                        <span>
                            <span className="number-count-value">{cartReducerData.drawdownrequestCart.length}</span>

                            <img src={LoanCartLogo} alt="LoanCartLogo" />
                        </span>
                    </OverlayTrigger>
                </Dropdown.Toggle>
                <Dropdown.Menu className="loan-request-cart">
                    <Row className="mx-0 p-16-20px border-bottom-E6E8F0">
                        <Col className='p-0'><h6 className="widget-title widget-title-color">Loan Request</h6></Col>
                        <Col className="text-right p-0"><p className='secondary-text-color'> Total Assets: {cartReducerData.drawdownrequestCart.length}</p></Col>
                    </Row>
                    <div className="content-section">
                        <Loader show={showLoader} styleType='absolute' />
                        <Row className="mx-0 p-0">
                            <Col xs={12} className='p-0 header-cart-items'>
                                {
                                    cartReducerData.drawdownrequestCart.map((item, index) => {

                                        return (
                                            <Row key={'ddrCartHeader' + index} className="mx-0 p-10-20px border-bottom-E6E8F0">
                                                <Col xs={8} className="p-0">
                                                    <Media>
                                                        {/* <Image src={carLogo} width={38} height={38} className="align-self-center mr-3 full-radius" /> */}
                                                        {item.carLogo ?
                                                            <span className="table-vehicle-logo"><Image src={item.carLogo} fluid /></span>
                                                            : <span className="table-vehicle-logo"><Image src={carLogo} className="align-self-center" /></span>}
                                                        <Media.Body className="align-self-center">
                                                            <b className='d-block vehicle-name-cart'>{item.vehicleName} </b>
                                                            <p><small>{getLoanTypes(sharedReducerData, item.loanType)} {item.loanSubType ? ' (' + item.loanSubType + ')' : ''}</small></p>
                                                        </Media.Body>
                                                    </Media>
                                                </Col>
                                                <Col xs={4} className="px-0 text-right">
                                                    <b className='d-block'>{item.sellerDetails ? currencifyInDollars(item.sellerDetails.requestedAmount) : ''}</b>
                                                    {!userDetails.readOnlyAccess ? <small onClick={() => removeVehicle(item._id)} className="cursor-pointer d-flex align-items-center justify-content-end">
                                                        <Image className='mr-1' width={12} src={deleteIcon} /> Remove
                                                    </small> : null}
                                                </Col>
                                            </Row>
                                        )

                                    })
                                }
                            </Col>
                            <Col xs={12}>
                                <Row className='greyish-bg-color p-5-20px'>
                                    <Col className="f-12-600-30 p-0">Total Cost</Col>
                                    <Col className="p-0 text-right">
                                        <b> {currencifyInDollars(cartReducerData.ddrTotalCost)}</b>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                    {!userDetails.readOnlyAccess ? <div className="padding-20 text-center">
                        <Button onClick={submitForFunding} onKeyDown={handleKeyDown} variant='primary' className="default-btn">Submit Flooring Request</Button>
                    </div> : null}
                </Dropdown.Menu>
            </Dropdown>
        </React.Fragment>) : null

    const paymentCart = cartReducerData.paymentsCart && cartReducerData.paymentsCart.length > 0 && !userDetails?.readOnlyAccess ?

        (<React.Fragment>
            <Dropdown alignRight={true} className="header-icons">
                <Dropdown.Toggle variant="success" id="dropdown-basic" className='complete-payment-btn'>
                    <OverlayTrigger onHide rootClose key="right" placement="bottom"
                        overlay={
                            <Tooltip id={`tooltip-brand`}>
                                Make Payments Cart
                            </Tooltip>
                        }>
                        <span>
                            <span className="number-count-value">{cartReducerData.paymentsCart.length}</span>
                            {/* <FontAwesomeIcon icon={faShoppingCart} /> */}
                            {/* <Image src={PaymentCartLogo} alt="PaymentCartLogo" /> */}
                            <img src={PaymentCartLogo} alt="LoanCartLogo" />
                        </span>
                    </OverlayTrigger>
                </Dropdown.Toggle>
                <Dropdown.Menu className="loan-request-cart">
                    <Row className="mx-0 p-16-20px border-bottom-E6E8F0">
                        <Col className='p-0'><h6 className="widget-title widget-title-color">Make Payments</h6></Col>
                        <Col className="text-right p-0"><p className='secondary-text-color'> Total Assets: {cartReducerData.paymentsCart.length}</p></Col>
                    </Row>
                    <div className="content-section">
                        <Row className="mx-0">
                            <Col xs={12} className="p-0 header-cart-items">
                                {
                                    cartReducerData.paymentsCart.map((item, index) => {

                                        return (
                                            <Row key={'paymentsCartHeader' + index} className="mx-0 p-10-20px border-bottom-E6E8F0">
                                                <Col xs={8} className="p-0">
                                                    <Media>
                                                        {/* <Image src={carLogo} width={38} height={38} className="align-self-center mr-3 full-radius" /> */}
                                                        {item.carLogo ?
                                                            <span className="table-vehicle-logo"><Image src={item.carLogo} fluid /></span>
                                                            : <span className="table-vehicle-logo"><Image src={carLogo} className="align-self-center mr-3" /></span>}
                                                        <Media.Body className="align-self-center">
                                                            <b className='d-block vehicle-name-cart'>{item.vehicleName ? item.vehicleName + (item.vin ? '(' + item.vin.substring(item.vin.length - 6) + ')' : '') : null} </b>
                                                            <small className='d-block'>{item.paymentType}</small>

                                                        </Media.Body>
                                                    </Media>
                                                </Col>
                                                <Col xs={4} className="p-0 text-right">
                                                    <b className='d-block'>{item.paymentAmount ? currencifyInDollars(item.paymentAmount) : ''}</b>
                                                </Col>
                                            </Row>
                                        )

                                    })
                                }
                            </Col>
                            <Col xs={12}>
                                <Row className='greyish-bg-color p-5-20px'>
                                    <Col className="f-12-600-30 p-0">Total Cost</Col>
                                    <Col className="p-0 text-right">
                                        <b>{currencifyInDollars(cartReducerData.paymentsTotalCost)}</b>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                    {(bankData?.bankpaymentData?.accounts?.length > 0 || isLender) ?
                        <div className="padding-20 text-center">
                            <Link to={isLender ? '/Admin/DealerCheckout' : '/Dealer/Checkout'}><Button variant='primary' className="default-btn">Submit Payment</Button></Link>
                        </div> :
                        <p className='col mx-auto d-flex align-items-start'>
                            <span className='d-flex'><AlertTriangle size={16} className='red-status-color' /></span>
                            <p className='content-text-13px d-inline-block mb-0 text-center red-status-color'>Please contact the administrator to connect with your bank accounts before submitting the payments.</p>
                        </p>
                    }
                </Dropdown.Menu>
            </Dropdown>
        </React.Fragment>) : null

    const notifications = props.notifications && props.notifications.length > 0 ?

        (<React.Fragment>
            <Dropdown alignRight={true} className="header-icons">
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                    <OverlayTrigger onHide rootClose key="right" placement="bottom"
                        overlay={
                            <Tooltip id={`tooltip-brand`}>
                                Notifications
                            </Tooltip>
                        }>
                        <span className="notificationItem"><span className="white-text">{props.notifications.length}</span><FontAwesomeIcon icon={faBell} /></span>
                    </OverlayTrigger>
                </Dropdown.Toggle>
                <Dropdown.Menu className="header-popups-boxshadow headerDropdowns">
                    <Row className="title-section">
                        <Col><h2 className="widget-title widget-title-color">Notifications</h2></Col>
                        <Col className="text-right"><span className="notificationcount blue-link-text"> {props.notifications.length} New</span></Col>
                    </Row>
                    <div className="content-section">

                        {
                            props.notifications.map((item, index) => {

                                return (
                                    <Row key={'notifications' + index} className="bottom--gray-border m-0 pb-2 mb-3">
                                        <Col className="pl-0 pb-2">
                                            <Media>
                                                <span className="align-self-center mr-3 ellipse-bg-color full-radius notificationname blue-link-text bold-500">{item.title ? item.title[0] : ''}</span>
                                                <Media.Body className="align-self-center">
                                                    <b>{item.title ? item.title : ''} </b>
                                                    <small>{item.description ? item.description : ''}</small>
                                                </Media.Body>
                                            </Media>
                                        </Col>
                                    </Row>
                                )

                            })
                        }

                    </div>
                    <div className="text-center mb-3">
                        <Button onClick={dispatch(readNotifications())} variant='primary' className="default-btn">Read all notifications</Button>
                    </div>
                </Dropdown.Menu>
            </Dropdown>
        </React.Fragment>) : null

    const getBubbleProfile = (data, showSignOutOnly = false) => {

        if (showSignOutOnly) {

            return (
                <div className="header-profile-dropdown-parent d-flex position-relative">
                    <Dropdown className="header-profile-dropdown">
                        <Dropdown.Toggle as={Dropdown} id="dropdown-custom-components">
                            <div className="profile-avatar darkblue-bg-color">
                                {/* <Image src={props && sharedReducerData.userDetails ? (sharedReducerData.userDetails.logo ? sharedReducerData.userDetails.logo : avatarLogo) : (
                userDetails && userDetails.logo ? userDetails.logo : avatarLogo)} rounded fluid /> */}
                                {
                                    sharedReducerData.userDetails ? (sharedReducerData.userDetails.logo ? <Image src={sharedReducerData.userDetails.logo} rounded fluid /> : <h6 className="white-text" >{sharedReducerData.userDetails.firstName ? sharedReducerData.userDetails.firstName.substring(0, 1) : null}</h6>) : (
                                        userDetails && userDetails.logo ? <Image src={userDetails.logo} rounded fluid /> : <h6 className="white-text">{userDetails.firstName ? userDetails.firstName.substring(0, 1) : null}</h6>)
                                }
                            </div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {sharedReducerData.userDetails ?
                                <React.Fragment>
                                    <h6 className="secondary-text-color">{sharedReducerData.userDetails?.firstName ?? ''} {sharedReducerData.userDetails?.lastName ?? ''}</h6>
                                    <p className="secondary-text-color">{sharedReducerData.userDetails?.dealerName ?? ''} {sharedReducerData.userDetails.organization?.toLowerCase() === 'dealer' ? 'Dealer' : (sharedReducerData.userDetails?.role ?? '')}</p>
                                </React.Fragment>
                                :
                                <React.Fragment>
                                    <h6 className="secondary-text-color">{userDetails?.firstName ?? ''} {userDetails?.lastName ?? ''}</h6>
                                    <p className="secondary-text-color">{userDetails?.dealerName ?? ''}</p>
                                </React.Fragment>
                            }
                            <Dropdown.Item eventKey="3" onClick={() => { !saveStatusChecker ? logOut() : setSaveChanges(true) }}>
                                <span><LogOut size={16} />Sign Out</span>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>);

        }
        else {

            return (<div className="header-profile-dropdown-parent d-flex position-relative">
                <Dropdown className="header-profile-dropdown">
                    <Dropdown.Toggle as={Dropdown} id="dropdown-custom-components">
                        <div className="profile-avatar darkblue-bg-color">
                            {/* <Image src={props && sharedReducerData.userDetails ? (sharedReducerData.userDetails.logo ? sharedReducerData.userDetails.logo : avatarLogo) : (
                userDetails && userDetails.logo ? userDetails.logo : avatarLogo)} rounded fluid /> */}
                            {
                                data && Object.keys(data).length > 0 ? (data.logo ? <Image src={data.logo} fluid /> : <h6 className="white-text p-0">{data.dealerName ? data.dealerName.substring(0, 1) : ''}</h6>) :
                                    (props && sharedReducerData.userDetails ? (sharedReducerData.userDetails.logo ? <Image src={sharedReducerData.userDetails.logo} fluid /> : <h6 className="white-text p-0">{sharedReducerData.userDetails.firstName ? sharedReducerData.userDetails.firstName.substring(0, 1) : null}</h6>) : (
                                        userDetails && userDetails.logo ? <Image src={userDetails.logo} fluid /> : <h6 className="white-text p-0">{userDetails.firstName ? userDetails.firstName.substring(0, 1) : null}</h6>))
                            }
                        </div>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {sharedReducerData.userDetails ?
                            <React.Fragment>
                                {
                                    data && Object.keys(data).length > 0 ?
                                        <React.Fragment>
                                            <h6 className="secondary-text-color">{data.firstName} {data.lastName}</h6>
                                            <p className="secondary-text-color">{data.dealerName}</p>
                                        </React.Fragment> :
                                        <React.Fragment>
                                            <h6 className="secondary-text-color">{sharedReducerData.userDetails.firstName} {sharedReducerData.userDetails.lastName}</h6>
                                            <p className="secondary-text-color">{sharedReducerData.userDetails.dealerName}</p>
                                        </React.Fragment>
                                }

                            </React.Fragment>
                            :
                            <React.Fragment>
                                {
                                    data && Object.keys(data).length > 0 ?
                                        <React.Fragment>
                                            <h6 className="secondary-text-color">{data.firstName} {data.lastName}</h6>
                                            <p className="secondary-text-color">{data.dealerName}</p>
                                        </React.Fragment> :
                                        <React.Fragment>
                                            <h6 className="secondary-text-color">{userDetails ? userDetails.firstName : ''} {userDetails ? userDetails.lastName : ''}</h6>
                                            <p className="secondary-text-color">{userDetails ? userDetails.dealerName : ''}</p>
                                        </React.Fragment>
                                }
                            </React.Fragment>
                        }
                        {(!props.hideProfile && sharedReducerData.userMenu?.some((item) => item.name === 'Profile')) ?
                            <Dropdown.Item eventKey="1">
                                <Link to={profileRoute}><Edit size={16} />Edit Profile</Link></Dropdown.Item> : null}
                        {(!props.hideProfile && sharedReducerData.userMenu?.find((item) => item.name === 'Profile')?.innerItems?.some((item1)=> item1.route === 'accountSettings')) ?
                            <Dropdown.Item eventKey="2">
                                <Link
                                    to={profileRoute}
                                    state={{ breadCrumbLink: 'accountSettings' }}
                                ><Key size={16} />Change Password</Link>
                            </Dropdown.Item> : null}
                        <Dropdown.Item eventKey="3" onClick={logOut}>
                            <span><LogOut size={16} />Sign Out</span>
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>);

        }

    }

    let bubbleIcons = '';
    let bubbleProfile = '';

    if (window.location.href.toLowerCase().indexOf(window.location.origin.toLowerCase() + '/admin') > -1) {

        if (lenderDealerPages.includes(location.pathname.toLowerCase())) {

            bubbleIcons = <React.Fragment>
                {ddrCart}
                {paymentCart}
                {notifications}
            </React.Fragment>

            bubbleProfile = getBubbleProfile(sharedReducerData.lenderSelectedDealerDetails);

        }
        else if (lenderSupplierPages.includes(location.pathname.toLowerCase())) {

            bubbleIcons = <React.Fragment>
                {notifications}
            </React.Fragment>

            bubbleProfile = getBubbleProfile(sharedReducerData.lenderSelectedSupplierDetails);

        }
        else {

            bubbleIcons = <React.Fragment>
                {notifications}
            </React.Fragment>

            bubbleProfile = getBubbleProfile(null, true);

        }

    }
    else if (window.location.href.toLowerCase().indexOf(window.location.origin.toLowerCase() + '/supplier') > -1) {

        bubbleIcons = <React.Fragment>
            {notifications}
        </React.Fragment>

        bubbleProfile = getBubbleProfile(null);

    }
    else {

        bubbleIcons = <React.Fragment>
            {ddrCart}
            {paymentCart}
            {notifications}
        </React.Fragment>

        bubbleProfile = getBubbleProfile(null);

    }

    const backToRedirection = (type) => {

        dispatch(setLenderBanner([]))
        dispatch(removeLenderSelectedDealerId())

        if (type === 'lender') {
            navigate('/Admin', {
                state: { backtoDealersTab: location.state && location.state.backtoDealersTab ? location.state.backtoDealersTab : (sharedReducerData.lenderSelectedDealerId && (isLender) ? 'dealers' : 'suppliers') }
            });
        } else if (type === 'dealer') {
            if (location?.state?.sopraSupplierReference) {
                navigate('/Admin/SupplierDetails', {
                    state: {
                        backtoDealersTab: "suppliers",
                        innerActiveTab: "Auction",
                        supplierId: location?.state?.userId
                    }
                })
                dispatch(changeAuctionTab('inventory'))
                let val = sharedReducerData?.backToSuplierData?.pendingrequest?.innerActiveTab
                if(val && Object.keys(val).length){
                    dispatch(changeAuctionTab('pendingrequest'))
                } else {
                    dispatch(changeAuctionTab('inventory'))
                }
            } else {
                let redirection = location.state && (location.state.backtoDealersTab == "SubscriptionManagement" || location.state.backtoDealersTab == "monthlyBilling") ? '/Admin/AccountManagement' : "/Admin"
                navigate(redirection, {
                    state: {
                        backtoDealersTab: location.state && location.state.backtoDealersTab ? location.state.backtoDealersTab : 'dealers',
                        innerActiveTab: location && location.state && location.state.innerActiveTab ? location.state.innerActiveTab : null,
                        historyType: location && location.state && location.state.historyType ? location.state.historyType : ''
                    }
                });
            }
        } else if (type === 'supplier') {
            navigate('/Admin', {
                state: {
                    backtoDealersTab: location.state && location.state.backtoDealersTab ? location.state.backtoDealersTab : 'suppliers',
                    innerActiveTab: location && location.state && location.state.innerActiveTab ? location.state.innerActiveTab : null,
                    historyType: location && location.state && location.state.historyType ? location.state.historyType : ''
                }
            });
        } else if (type === 'supplierLogin') {
            navigate('/Supplier', {
                state: {
                    supplierId: location?.state?.userId
                }
            })
            let val = sharedReducerData?.backToSuplierData?.pendingrequest?.innerActiveTab
            if(val && Object.keys(val).length){
                dispatch(changeAuctionTab('pendingrequest'))
            } else {
                dispatch(changeAuctionTab('inventory'))
            }
        }
    }
    return (
        <>
            <Row className='headerComponent' ref={headerRef}>
                <Col lg={9} sm={7} xs={12} className={'p-0 d-flex align-items-center' + (props.lenderBanner ? ' username-lender-banner' : '')}>
                    {sharedReducerData.userDetails ?
                        sharedReducerData.lenderSelectedDealerName ?
                            <div>
                                <h1 className='line-height-initial'>Welcome, {`${sharedReducerData.userDetails.firstName}  ${sharedReducerData.userDetails.lastName}  ${sharedReducerData?.lenderSelectedSupplierDetails?.dealerName ?? ''}`}
                                    {location && lenderDealerPages.includes(location.pathname.toLowerCase()) &&
                                        sharedReducerData.lenderSelectedDealerName && window.location.href.toLowerCase().indexOf(window.location.origin.toLowerCase() + '/admin/vehicledetails') === -1 ?
                                        <> - {sharedReducerData.lenderSelectedDealerName}
                                        </> : ''}
                                    <p className='secondary-text-color'>{convertToBaseFormatDate(new Date(), false)}</p>
                                    {location && lenderDealerPages.includes(location.pathname.toLowerCase()) &&
                                        sharedReducerData.lenderSelectedDealerName && window.location.href.toLowerCase().indexOf(window.location.origin.toLowerCase() + '/admin/vehicledetails') === -1 ?
                                        <><OverlayTrigger placement="bottom"
                                            overlay={
                                                <Tooltip>View Dealer Notes</Tooltip>}>
                                            <span className='cursor-pointer ml-1'>
                                                <img src={NotesSquare} alt="view notes"
                                                    onClick={(event) => getNotes()} />
                                            </span>
                                        </OverlayTrigger>
                                        </> : ''}
                                    <span className='ml-1'>
                                        <TagsInfo
                                            tagtype="dealer"
                                            tagsData={sharedReducerData?.lenderSelectedDealerDetails?.userTags}
                                        />
                                    </span>

                                </h1>
                            </div>


                            : <h1 className='line-height-initial'>Welcome, {multiDealerName ? multiDealerName : <span>{sharedReducerData.userDetails.firstName} {sharedReducerData.userDetails.lastName}</span>}

                                {location && lenderSupplierPages.includes(location.pathname.toLowerCase()) &&
                                    sharedReducerData.lenderSelectedSupplierDetails && sharedReducerData.lenderSelectedSupplierDetails.dealerName ?
                                    <> - {sharedReducerData.lenderSelectedSupplierDetails.dealerName}

                                    </>
                                    : ''}
                                <p className='secondary-text-color'>{convertToBaseFormatDate(new Date(), false)}</p>
                                {lenderSupplierPages.includes(location.pathname.toLowerCase()) ?
                                    <OverlayTrigger placement="bottom"
                                        overlay={
                                            <Tooltip>View Supplier Notes</Tooltip>}>
                                        <span className='cursor-pointer ml-1'>
                                            <img src={NotesSquare} alt="view notes"
                                                onClick={(event) => getNotes()}
                                            />
                                        </span>
                                    </OverlayTrigger> : ''}

                            </h1>
                        :
                        sharedReducerData.lenderSelectedDealerName ?
                            <h1 className='line-height-initial'>Welcome, {userDetails ? userDetails.firstName : ''} {userDetails ? userDetails.lastName : ''}
                                {location && lenderDealerPages.includes(location.pathname.toLowerCase())
                                    && sharedReducerData.lenderSelectedDealerName ? '- ' + sharedReducerData.lenderSelectedDealerName : ''}
                                <p className='secondary-text-color'>{convertToBaseFormatDate(new Date(), false)}</p>
                            </h1>
                            :
                            <h1 className='line-height-initial'>Welcome, {userDetails ? userDetails.firstName : ''} {userDetails ? userDetails.lastName : ''}
                                {location && lenderSupplierPages.includes(location.pathname.toLowerCase()) &&
                                    sharedReducerData.lenderSelectedSupplierDetails && sharedReducerData.lenderSelectedSupplierDetails.dealerName ? '- ' + sharedReducerData.lenderSelectedSupplierDetails.dealerName : ''}
                                <p className='secondary-text-color'>{convertToBaseFormatDate(new Date(), false)}</p>
                            </h1>

                    }

                    {props.lenderBanner ?
                        <div className='pl-2 header-lender-banner'>{props.lenderBanner}</div> : ''
                    }
                </Col>

                <Col lg={3} sm={5} xs={10} className="text-right header-profile p-0">
                    <Notifications setToaster={(data) => setToaster(data)} />
                    {isLenderOrSupplier ? <GlobalSearchField /> : null}
                    {bubbleIcons}
                    {isLenderOrSupplier ? notifications : null}
                    {isLenderAccessedCustomerSupport ?
                        <OverlayTrigger onHide rootClose key="right" placement="bottom"
                            overlay={
                                <Tooltip id={`tooltip-brand`}>
                                    {isLender ? 'Back to Lender' : null}
                                </Tooltip>
                            }>
                            <FontAwesomeIcon icon={faAngleDoubleLeft} className="cartItem icon-color mr-3" onClick={() => backToRedirection('lender')} />

                        </OverlayTrigger >
                        : ''}

                    {
                        location && lenderDealerPages.includes(location.pathname.toLowerCase()) ?
                            <OverlayTrigger onHide rootClose key="right" placement="bottom"
                                overlay={
                                    <Tooltip id={`tooltip-brand`}>
                                        {isLender ? 'Back to Organization' : `${location?.state?.sopraSupplierReference ? 'Back to Supplier' : null}`}
                                    </Tooltip>
                                }>
                                <FontAwesomeIcon className='icon-color cartItem mr-3' icon={faAngleDoubleLeft} onClick={() => backToRedirection('dealer')} />

                            </OverlayTrigger>
                            : ''
                    }

                    {
                        location && lenderSupplierPages.includes(location.pathname.toLowerCase()) ?
                            <OverlayTrigger onHide rootClose key="right" placement="bottom"
                                overlay={
                                    <Tooltip id={`tooltip-brand`}>
                                        {isLender ? 'Back to Organization' : null}
                                    </Tooltip>
                                }>
                                <FontAwesomeIcon icon={faAngleDoubleLeft} className='cartItem icon-color mr-3' onClick={() => backToRedirection('supplier')} />
                            </OverlayTrigger>
                            : ''
                    }

                    {/* <span className="cartItem searchIcon"><FontAwesomeIcon icon={faSearch} /></span> */}
                    {
                        userDetails?.organization?.toLowerCase() === 'supplier' && location?.pathname === '/Supplier/VehicleDetails' ?
                            <OverlayTrigger onHide rootClose key="right" placement="bottom"
                                overlay={
                                    <Tooltip id={`tooltip-brand`}>
                                        Back to Supplier
                                    </Tooltip>
                                }>
                                <FontAwesomeIcon icon={faAngleDoubleLeft} className='cartItem icon-color mr-3' onClick={() => backToRedirection('supplierLogin')} />
                            </OverlayTrigger>
                            : ''
                    }

                    {bubbleProfile}
                </Col >
            </Row >
            <div>
                {saveStatusChecker && saveChanges ?
                    <SavestatusChecker
                        showModal={saveChanges}
                        setShowModal={setSaveChanges}
                        Type='Header'
                        PrimaryAction={logOut}
                    /> : null}
            </div>
            {notesListState && notesListState.showModal ?
                <ViewNotes
                    activeTab={sharedReducerData.lenderSelectedSupplierDetails && sharedReducerData.lenderSelectedSupplierDetails._id ? 'Supplier Note' : 'Dealer Note'}
                    showModal={notesListState.showModal}
                    restrictVehicleId={true}
                    selectedDealerID={notesListState.dealerId}
                    selectedDealer={notesListState?.selectedDealer}
                    hideNotesViewModal={() => setNotesListState({
                        ...notesListState,
                        showModal: false
                    })}
                    isSupplier={sharedReducerData.lenderSelectedSupplierDetails && sharedReducerData.lenderSelectedSupplierDetails._id ? true : false}
                    // isLenderBanner={sharedReducerData.lenderSelectedSupplierDetails?._id ? false : true}
                /> : null}

        </>
    )
}



export default HeaderComponent;